import { create } from 'zustand';

type ModelSelectorMenuState = {
  openByResourceId: Record<string, boolean>;
  setOpen: (resourceId: string, open: boolean) => void;
};

export const useModelSelectorMenuStore = create<ModelSelectorMenuState>((set) => ({
  openByResourceId: {},
  setOpen: (resourceId, open) =>
    set((state) => ({
      openByResourceId: { ...state.openByResourceId, [resourceId]: open },
    })),
}));

export const useModelSelectorMenuOpen = (resourceId: string) =>
  useModelSelectorMenuStore((state) => state.openByResourceId[resourceId] ?? false);

export const useSetModelSelectorMenuOpen = () => useModelSelectorMenuStore((state) => state.setOpen);
